import { useState, memo, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import { getTransactionResult } from "../../Actions/Actions";
import SpinnerButton from "../../Components/SpinnerButton";
import ModalResult from "../../Components/ModalResult";
import { setLogIn, setOtp } from "../../Actions/Actions";
import ModalOtp from "../../Components/ModalOtp";
import Business from "../../Components/Business";
import Loading from "../../Components/Loading";
import Logo from "../../Components/Logo";
import "./styles.css";
import { axios } from "../../Actions/CommonActions";
import Api from "../../Constants/Api";

const Screen = (props) => {
    const [modalResult, setModalResult] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [modalOtp, setModalOtp] = useState(false);
    const [loading, setLoading] = useState(false);
    const [otpCode, setOtpCode] = useState("");
    const [detail, setDetail] = useState({});
    const history = useHistory();
    const transactionId = props.location.state;

    useEffect(() => {
        if (otpCode.toString().length === 6) {
            onClickSubmitOtp();
        }
    }, [otpCode]);

    const onClickGetOtp = () => {
        if (typeof phoneNumber === "string" && phoneNumber.toString().length < 11) {
            toast("شماره موبایل الزامی است", { type: "warning" });
        } else {
            setBtnLoading(true);
            // login api
            setLogIn(phoneNumber).finally(_ => {
                setBtnLoading(false);
                setModalOtp(true);
            });
        }
    };

    const onClickSubmitOtp = () => {
        setBtnLoading(true);
        const params = {
            phoneNumber: phoneNumber,
            code: otpCode
        };
        // get access token
        setOtp(params).then(res => {
            // api call
            const url_string = window.location.href;
            const url = new URL(url_string);
            const direct_payment_id = url.searchParams.get("direct_payment_id");
            const accessToken = sessionStorage.getItem("Access_Token");

            if (direct_payment_id) {
                axios({
                    method: "GET",
                    baseURL: Api.AGENCY_API,
                    url: `/gateway/direct/payment/${direct_payment_id}`,
                    headers: {
                        Authorization: "Bearer " + accessToken
                    },
                })
                    .then((res) => {
                        let data = res.data.data;
                        let payment_options_data = res.data.data.payment_options_data;

                        if (payment_options_data.show_payment_options) {
                            getTransactionResult(data.transaction_id)
                                .then((result) => {
                                    if (result?.redirect === "payment_gateway") {
                                        history.push({
                                            pathname: "/payment",
                                            state: { result, transactionId: data.transaction_id },
                                        });
                                    } else if (result?.redirect === "payment_gateway_callback") {
                                        history.push({
                                            pathname: "/result",
                                            state: result,
                                        });
                                    } else {
                                        setDetail({
                                            status: "failed",
                                            title: "خطا",
                                            body: "درگاه پرداخت با مشکل مواجه شد",
                                            dismissible: true,
                                        });
                                        setModalResult(true);
                                    }
                                })
                                .catch((err) => {
                                    if (err?.status === 401) {
                                        history.push({
                                            pathname: "/sign-in",
                                            state: transactionId,
                                        });
                                    } else {
                                        setDetail({
                                            status: "failed",
                                            title: "خطا",
                                            body: err?.data?.message,
                                            dismissible: true,
                                        });
                                        setModalResult(true);
                                    }
                                });
                        } else {
                            axios({
                                method: "POST",
                                baseURL: Api.PUBLIC_API_V2,
                                url: "daap/wallets/payment",
                                data: payment_options_data.payment_data.payload,
                            })
                                .then((res) => {
                                    const link = res.data.data.redirect_url;
                                    window.location.href = link;
                                })
                        }
                    }).catch((err) => {
                        // setDetail({
                        //     status: "failed",
                        //     title: "خطا",
                        //     body: err?.data?.message || err?.message,
                        //     dismissible: true,
                        // });
                        // setModalResult(true);
                        toast(err?.response?.data?.message || err?.message, { type: "warning" });
                    });
            } else {
                getTransactionResult(transactionId).then(result => {
                    if (result && result?.redirect && result?.redirect === "payment_gateway") {
                        history.push({
                            pathname: "/payment",
                            state: {
                                result: result,
                                transactionId: transactionId
                            }
                        });
                    } else if (result?.redirect === "payment_gateway_callback") {
                        history.push({
                            pathname: "/result",
                            state: result
                        });
                    } else {
                        const data = {
                            status: "failed",
                            title: "خطا",
                            body: "",
                            dismissible: true
                        };
                        setDetail(data);
                        setModalResult(true);
                    }
                });
            }
            setModalOtp(false);
        }).catch(err => {
            const data = {
                status: "failed",
                title: "خطا",
                body: err?.data?.message,
                dismissible: true
            };
            setDetail(data);
            setModalResult(true);
        }).finally(_ => {
            setBtnLoading(false);
        });
    };

    return (
        <div className="sign-in">
            {
                !loading ?
                    <Fragment>
                        <Logo />
                        {/* <Business 
                        data={detail}
                    /> */}
                        <div className="sign-in-form">
                            <p className="sign-in-form-p">شماره موبایل<span className="sign-in-form-span">*</span></p>
                            <input
                                placeholder="مثال: 09120000000"
                                className="sign-in-form-input"
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                maxLength={11}
                            />
                            <SpinnerButton
                                className="sign-in-form-btn"
                                text="ارسال کد تایید"
                                onClick={onClickGetOtp}
                                loading={btnLoading}
                            />
                        </div>
                    </Fragment>
                    :
                    <Loading />
            }
            <ModalOtp
                show={modalOtp}
                onChange={(value) => setOtpCode(value)}
                closeModal={() => setModalOtp(false)}
                onClickSubmitOtp={onClickSubmitOtp}
                onclickGetAgainCode={onClickGetOtp}
                loading={btnLoading}
            />
            <ModalResult
                show={modalResult}
                onClose={() => setModalResult(false)}
                result={detail}
            />
        </div>
    );
};
export default memo(Screen);